<template>
    <div class="form-group" v-if="IsShow">
        <h6 v-if="labelText">{{ $t(labelText) }}<span class="text-danger" v-if="validationRules"> *</span></h6>
        <div class="d-flex align-items-center justify-content-start">
            <div :class="['media-body icon-state', size === 'small' ? 'switch-sm' : size === 'medium' ? 'switch-md' : '']">
                <label class="switch">
                    <input type="checkbox" v-model="temp_value" @input="$emit('input', !value)" v-bind="$attrs">
                    <span class="switch-state"></span>
                </label>
            </div>
            <div class="ml-2" v-if="!IsHidenText">
                <span class="switch-text" v-if="temp_value">{{ GetLeftTitle }}</span>
                <span class="switch-text" v-if="!temp_value">{{ GetRightTitle }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    props: ["value", "ControlId", "isshow", "mandatory", "title","left","right","IsHidenText", "size"],
    data() {
        return {
            temp_value: this.value,
            IsShow: true,
            labelText: this.title,
            mandatoryText: this.mandatory,
            validationRules: null,
        }
    },

    computed: {
        ...mapGetters({
            GetPermissionJsonById: 'responsePermission/getPermissionJsonById',
        }),
        record() {
            return this.GetPermissionJsonById({ ControlId: this.ControlId })
        },
        GetLeftTitle(){
            return this.left ? this.left : this.$t('lbl_EMPBE_SwitchYes');
        },
        GetRightTitle(){
            return this.right ? this.right : this.$t('lbl_EMPBE_SwitchNo');
        }
    },
    watch: {
        title(){
            this.labelText = this.title;
        },
        value() {
            this.temp_value = this.value;
        }
    },
    mounted() {
        //read from json
        if (this.record != null) {
            if (this.record.IsShow != null) this.IsShow = this.record.IsShow;
            if (this.record.IsMandatory) this.validationRules = { required: true };
            if (this.record.IsDisable != null) this.$attrs["disabled"] = this.record.IsDisable;
            if (this.record.Label != null) this.labelText = this.$t(this.record.Label);
            if (this.record.PlaceholderLabel != null) this.$attrs["placeholder"] = this.$t(this.record.PlaceholderLabel);
            if (this.record.MandatoryLabel != null) this.mandatoryText = this.$t(this.record.MandatoryLabel);
            if (this.record.MaxLength != null) this.$attrs["maxlength"] = this.record.MaxLength;
            if (this.record.MinLength != null) this.$attrs["minlength"] = this.record.MinLength;
        }
    },
    methods: {
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
    }
}
</script>
<style scoped lang="scss">
.media-body {
    flex: 0;
}
label.switch {
    margin-bottom: 0;
}
.switch-text {
    font-size: 16px;
}
.switch-state{
    background-color: #a9a9a9;
}
.switch {
    > input[type="checkbox"]:disabled + .switch-state {
        cursor: not-allowed;
    }
}

/* 中等尺寸版本：52px × 32px */
.switch-md.icon-state {
    .switch {
        width: 52px !important;
        height: 32px !important;
        margin-top: 0px !important;
        margin-bottom: 0px !important;
        
        .switch-state {
            &:before {
                width: 24px !important;
                height: 24px !important;
                bottom: 4px !important;
                left: 4px !important;
            }
            
            &:after {
                left: 10px !important;
                top: 10px !important;
                font-size: 14px !important;
            }
        }
        
        input:checked + .switch-state {
            &:before {
                transform: translateX(20px) !important;
            }
            
            &:after {
                left: 30px !important;
            }
        }
    }
    
    .switch-text {
        font-size: 15px;
    }
}

/* 小尺寸版本：39px × 24px */
.switch-sm.icon-state {
    .switch {
        width: 39px !important;
        height: 24px !important;
        margin-top: 0px !important;
        margin-bottom: 0px !important;
        
        .switch-state {
            &:before {
                width: 18px !important;
                height: 18px !important;
                bottom: 3px !important;
                left: 3px !important;
            }
            
            &:after {
                left: 6px !important;
                top: 6px !important;
                font-size: 11px !important;
            }
        }
        
        input:checked + .switch-state {
            &:before {
                transform: translateX(15px) !important;
            }
            
            &:after {
                left: 21px !important;
            }
        }
    }
    
    .switch-text {
        font-size: 14px;
    }
}
</style>